/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const INFO_VIEWBOX = 20;

/** Filled info-in-circle (20×20 asset). */
const INFO_PATH =
  'M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11V14C9 14.5523 9.44772 15 10 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V10C11 9.44772 10.5523 9 10 9H9Z';

/** Default solid fill for alert / emphasis usage — `--pal-blue-1000` from `_palette-maps.scss`, hex fallback. */
export const INFO_FILLED_ICON_DEFAULT_FILL = 'var(--pal-blue-1000, #101AA8)';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Info-in-circle (20×20). Color via `fill` (default `currentColor`).
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const InfoIcon = ({
  size = 20,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${INFO_VIEWBOX} ${INFO_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path fillRule="evenodd" clipRule="evenodd" d={INFO_PATH} fill={fill} />
  </svg>
);

InfoIcon.propTypes = {
  ...iconPropTypes,
  /** Any valid SVG fill, e.g. `currentColor`, `INFO_FILLED_ICON_DEFAULT_FILL`, `var(--ds-color-info)`. */
  fill: PropTypes.string,
};

export { InfoIcon };
export default InfoIcon;
